export default __webpack_public_path__ + "static/media/memecoin.a33c1947.png";